export default __webpack_public_path__ + "static/media/mainBC.cf432b60.png";